<div id="login" class="inner-scroll login-main">
  <div class="absolute inset-0 top-0 left-0">
    <img src="../images/new/dark-material-bg.jpg" class="h-full object-cover" />
  </div>
  <div id="login-form-wrapper" class="login-wrapper bg-white">

    <div id="login-form" class="p-relative w-full shadow-none"
      [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">
      <!-- <div class="login-backbutton">
        <a href="https://bizzsecure.com" mat-icon-button matTooltip="Back to Bizzsecure">
          <mat-icon>arrow_back</mat-icon>
        </a>
      </div> -->
      @if(apiResponseErrorMessage!=null){
      <div class="message-box error mb-10 mt-24">
        <span class="custom-span-pre">{{apiResponseErrorMessage}}</span>
      </div>
      }

      @if(isFirstStep && !iscompanyCodeStep){
      <div>
        <div class="w-40 m-auto">
          <img src="../images/new/biz-logo.png" alt="Logo">
        </div>
        <!-- <div class="logo mt-4 mb-16">
            <a href="https://bizzsecure.com">
              <img src="assets/images/logos/biz-logo.png" alt="Alternate Text" />
            </a>
          </div> -->
        <!-- Title -->
        <div class="mt-5 auth-title">
          Sign in
        </div>
        <div class="mt-0.5 flex items-baseline font-medium justify-center">
          <div>Don't have an account?</div>
          <a class="ml-1 text-primary-500 hover:underline" [routerLink]="'/main/company/sign-up'">Sign up
          </a>
        </div>
        <form class="mt-8" name="loginForm" [formGroup]="loginForm" (submit)="login()" novalidate>
          <mat-form-field>
            <input matInput placeholder="Email" formControlName="email" required>
            @if(loginForm.get('email').hasError('required')){
            <mat-error>
              Email is required
            </mat-error>
            }

            @if(!loginForm.get('email').hasError('required') && loginForm.get('email').hasError('invalidEmailAddress')){
            <mat-error>
              Please enter a valid email address
            </mat-error>
            }
          </mat-form-field>

          <mat-form-field>
            <input matInput type="password" placeholder="Password" formControlName="password" required>
            <mat-error>
              Password is required
            </mat-error>
          </mat-form-field>

          <div class="remember-forgot-password mt-1.5 inline-flex w-full items-center justify-between">
            <mat-checkbox class="-ml-2 remember-me" [color]="'primary'" [formControlName]="'rememberMe'"
              (change)="rememberMe($event)">
              Remember me
            </mat-checkbox>
            <!-- <mat-checkbox class="remember-me" color="primary" aria-label="Remember Me" (change)="rememberMe($event)">
                Remember Me
              </mat-checkbox> -->

            <a class="forgot-password text-md font-medium text-primary-500 hover:underline"
              [routerLink]="'/auth/forgotpassword'">
              Forgot Password?
            </a>
          </div>

          <button type="submit" mat-raised-button color="primary"
            class="fuse-mat-button-large submit-button bg-primary text-white w-full" aria-label="LOGIN"
            [disabled]="!loginForm.valid||isSubmitBtnDisabled">
            LOGIN
          </button>

        </form>

        <!-- <div class="register mb-4 mt-16 flex justify-center" fxLayout="row wrap" fxLayoutAlign="center center">
            <span class="text">Don't have an account?</span>
            <a class="link" [routerLink]="'/main/company/sign-up'">Sign Up</a>
          </div> -->
        <div class="register mb-4 mt-8 flex justify-center" fxLayout="row wrap" fxLayoutAlign="center center">
          <a class="link" [routerLink]="'/auth/privacy'">Privacy Policy</a> &nbsp; | &nbsp; <a class="link"
            [routerLink]="'/auth/terms'">Terms Of Use</a>
        </div>

      </div>
      }

      @if(!isFirstStep){
      <div id="divVerifyCode">
        <div class="logo mt-4 mb-16">
          <a href="https://bizzsecure.com">
            <img src="../images/new/biz-logo.png" alt="Logo">
          </a>
        </div>

        <div class="title mb-16">VERIFY YOUR CODE</div>
        <form name="verifyCodeForm" [formGroup]="verifyCodeForm" (submit)="verifyCode()" novalidate>
          <mat-form-field>
            <input matInput type="text" placeholder="Code" formControlName="code" required>
            <mat-error>
              @if(verifyCodeForm.get('code').hasError('required')){
              <span>Code is required. </span>
              }

              @if(!verifyCodeForm.get('code').hasError('required')){
              <span>
                Code must be numeric.
              </span>
              }
            </mat-error>
          </mat-form-field>

          <button type="submit" mat-raised-button color="primary" class="submit-button" aria-label="LOGIN"
            [disabled]="!verifyCodeForm.valid">
            Verify Code
          </button>
          <div class="mb-4 mt-8 flex justify-center font-medium" fxLayout="row wrap" fxLayoutAlign="center center">
            <a  href="javascript:void(0);" (click)="backToFirstStep(true)" class="link text-primary-500 hover:underline">Go back to login page</a>
          </div>
          
        </form>
      </div>
      }


      @if(iscompanyCodeStep){
      <div id="divCompanyCode">
        <div class="logo mt-4 mb-16">
          <a href="javascript:;" onclick="doLogOut()">
            <img src="../images/new/biz-logo.png" alt="Logo">
          </a>
        </div> 
         <!-- Title -->
        <div class="mt-5 auth-title">
          Verify Company Code
        </div>

        <div class="title mb-16">VERIFY COMPANY CODE</div>
        <form name="companyCodeForm" [formGroup]="companyCodeForm" (submit)="verifyCompanyCode()" novalidate>

          <mat-form-field>
            <input #loginCompanyAutoComplete matInput placeholder="Please Select Company"
              [formControl]="autoCompleteCompanyListFormControl" class="company-select-box"
              (input)="onInputChanged($event.target.value)" [matAutocomplete]="auto" required />
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFnAutoComplete">
              @for( item of companyAutocompleteList; track item){
              <mat-option (onSelectionChange)="onChangeCompany($event)" [value]="item">
                <span> {{ item.companyName }}</span>
                @if(item.isFavourite){
                <mat-icon class="amber-600-fg">star</mat-icon>
                }

                @if(!item.isFavourite){
                <mat-icon class="amber-600-fg">star_border</mat-icon>
                }


              </mat-option>
              }
            </mat-autocomplete>
            <mat-error>
              @if(autoCompleteCompanyListFormControl.value == null){
              <span>Please select company. </span>
              }

            </mat-error>
          </mat-form-field>

          @if(isCompanySecurityCodeAvailable){
          <mat-form-field>
            <input matInput type="password" placeholder="Code" formControlName="code" required>
            <mat-error>
              @if(companyCodeForm.get('code').hasError('required')){
              <span>Company Code is required.</span> &nbsp;
              }

              @if(companyCodeForm.get('code').hasError('pattern')){
              <span>Only numeric values allowed</span> &nbsp;
              }

              @if(!companyCodeForm.get('code').hasError('required') &&
              companyCodeForm.get('code').hasError('maxlength')){
              <span>Maximum 4 digit allowed</span>
              }
            </mat-error>
          </mat-form-field>
          <button type="submit" mat-raised-button color="primary" class="submit-button" aria-label="Verify Code"
            [disabled]="!companyCodeForm.valid && autoCompleteCompanyListFormControl.value == null">
            Verify Code
          </button>
          }

          @if(!isCompanySecurityCodeAvailable){
          <mat-form-field>
            <input matInput type="text" placeholder="Code" [disabled]="true">
          </mat-form-field>

          <button type="submit" mat-raised-button color="primary" class="submit-button" aria-label="Verify Code"
            [disabled]="autoCompleteCompanyListFormControl.value == null">
            Verify Code
          </button>
          }



          <div class="message text-center">
            <a href="javascript:void(0);" class="link" (click)="backToFirstStep(true)">Go back to login page</a>
          </div>
         
        </form>
      </div>
      }

    </div>
  </div>
</div>